import { render, staticRenderFns } from "./MyNumbers.vue?vue&type=template&id=6b4d2229&scoped=true&"
import script from "./MyNumbers.vue?vue&type=script&lang=js&"
export * from "./MyNumbers.vue?vue&type=script&lang=js&"
import style0 from "./MyNumbers.vue?vue&type=style&index=0&id=6b4d2229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d2229",
  null
  
)

export default component.exports